import { createAction, props } from '@ngrx/store';
import { IUser, ISCDUser, IUserSettings } from '@app-root-interfaces';

export const getUser = createAction('[User] Get User', props<{ gid: string }>());

export const getUserSuccess = createAction('[User] Get User success', props<{ user: IUser; isAdmin: boolean }>());

export const getScdUserForInitialUserCreate = createAction(
    '[User] Get SCD user for initial user create',
    props<{ gid: string }>()
);

export const createInitialUser = createAction('[User] Create initial user', props<{ scdUser: ISCDUser }>());

export const createInitialUserSuccess = createAction(
    '[User] Create initial user success',
    props<{ user: IUser; isAdmin: boolean }>()
);

export const toggleFavouriteFromUser = createAction(
    '[User] Toggle favourite from User',
    props<{ documentId: string }>()
);

export const toggleFavouriteFromUserSuccess = createAction(
    '[User] Toggle favourite from User success',
    props<{ user: IUser }>()
);

export const addRecentlySeenToUser = createAction('[User] Add recently seen to User', props<{ documentId: string }>());

export const addRecentlySeenToUserSuccess = createAction(
    '[User] Add recently seen to User success',
    props<{ user: IUser }>()
);

export const updateUserSettings = createAction('[User] Update User Settings', props<{ settings: IUserSettings }>());

export const updateUserSettingsSuccess = createAction('[User] Update User Settings Success', props<{ user: IUser }>());

export const setIsAdmin = createAction('[User] Set is admin', props<{ isAdmin: boolean }>());

export const setIsAdminSuccess = createAction('[User] Set is admin success', props<{ isAdmin: boolean }>());
